import { Flex, Rating, Text, Title } from '@mantine/core';
import { formatRatingValue, pluralize } from '@shared/utils';
import { IconStarOff } from '@tabler/icons-react';
import classes from './CandidateRating.module.scss';

type CandidateRatingProps = {
  rating?: number | null;
};

export const CandidateRating = ({ rating }: CandidateRatingProps) => {
  const hasRating = rating != null;
  let unit = 'балла';
  if (rating != null) {
    unit = pluralize(rating, ['балл', 'балла', 'баллов']);
  }

  return (
    <Flex
      className={classes.wrapper}
      direction='column'
      gap={16}
      maw={418}
      p={24}
    >
      <Text size='lg' fw={600}>
        Оценка кандидата
      </Text>

      <Flex
        className={classes.ratingBar}
        gap={24}
        align='center'
        justify='space-between'
      >
        {hasRating ? (
          <>
            <Flex h={64} className={classes.ratingBadge}>
              <Rating
                value={rating}
                fractions={2}
                h='fit-content'
                readOnly
                color='yellow'
                size='lg'
              />
            </Flex>
            <Title order={4} lh='24px' pr={12}>
              {formatRatingValue(rating)} {unit}
            </Title>
          </>
        ) : (
          <>
            <Flex className={classes.ratingBadge} w={149} h={64}>
              <IconStarOff size={16} color='var(--mantine-color-tertiary-2)' />
              <Text size='xs' c='tertiary.7'>
                Нет оценок
              </Text>
            </Flex>

            <Title order={4} lh='24px' pr={12}>
              0 балла
            </Title>
          </>
        )}
      </Flex>
    </Flex>
  );
};
